import {User} from "../types/User";
import ReportOwnerAccount from "../types/ReportOwnerAccount";

export const isUserSubscriptionActive = (user: User | ReportOwnerAccount) => {
    return user.subscription_status === "active";
}